export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "可游漫画网主要提供哪些内容？",
    a: "可游漫画网聚焦游戏资讯与联动情报，跟进新游漫画化、版本更新漫画及活动漫画内容，帮助你第一时间掌握热门游戏的漫画化动态与联动活动信息。",
  },
  {
    q: "新游漫画化的内容多久更新一次？",
    a: "新游漫画化板块会跟随游戏官方发布节奏及时更新，通常在游戏新版本上线或官方公开漫画企划后，我们会第一时间整理并发布相关内容和解读。",
  },
  {
    q: "版本更新漫画在哪里查看？",
    a: "你可以在首页的「版本更新」栏目中找到相关漫画的资讯与解析文章，也可以通过顶部导航进入「版本更新」专栏查看全部相关内容。",
  },
  {
    q: "网站内容是免费阅读的吗？",
    a: "是的，可游漫画网上的所有资讯文章、漫画情报解读和栏目内容都可以免费浏览，无需注册即可阅读。",
  },
  {
    q: "如何向可游漫画网投稿或反馈？",
    a: "你可以通过「投稿咨询」页面提交你的稿件、情报线索或意见反馈，我们会尽快审阅并与你联系，感谢你的支持。",
  },
  {
    q: "联动情报是怎么收集的？",
    a: "我们持续关注各大游戏厂商与动画、漫画IP的官方动态，通过官方公告、发布会与公开资料整理联动情报，确保信息来源准确可靠。",
  },
];